import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
import { Link } from "../../lib/Link";

export const voice_case2 = type => {
  document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜お客様インタビュー｜引っ越すよりお得！？'; 
  return (
    <div className="container">
      {breadcrumbs(type, [
        { href: "/voice2/", text: "お客様の声" },
        { text: " 引っ越すよりお得！？" },
      ])}
      
      <div className="voice_case">
        <h2>活用事例</h2>
        <div className="content">
          <div className="collection">
            <div className="interview_header">
              <div className="title">お客様のご紹介</div>
              <div className="person">
                <span>まかろん様</span>
                <br />
                <span>建築会社勤務　30代　既婚</span>
                <br />
                <span>板橋区在住　お住まい：社宅</span>
              </div>
              <div className="profile">
                <span>仕事と育児を両立するワーキングマザー</span>
                <span>
                  今年4月、部署異動により、残業が多い部署に。改めて時間管理の大切さを痛感しているそう。
                </span>
              </div>
            </div>
            <Link to="/tokyo/itabashiku/detail/2509/" className="item attention">
              <div className="type star">物件データ</div>
              <div className="title">
                  ハローストレージ板橋蓮根パート2
              </div>
              <div className="price">
                5,800 /月〜 28,100 /円/月 (0.5帖〜3帖)
              </div>
              <div className="address">東京都板橋区蓮根2丁目3-3</div>
              <div className="transportation">
                都営三田線　蓮根 駅　徒歩 7 分
              </div>
              <div className="image outside" />
            </Link>
          </div>
          <div className="h_border" />
          <div className="interview">
            <img src="resource/img/static/voice2/voice_case2/img_1.jpg" />
            <div className="title">引っ越すよりお得！？</div>
            <div className="question">Ｑ：借りようと思ったきっかけは？</div>
            <div className="answer">
              <span>
                子供の成長にあわせて必要なモノが変わるし増えるしで困ってました。
              </span>
              <span>
                しかも我が家の場合、上の子と下の子の年の差が3歳。下の子にも使わせたいものもあるし、売る
              </span>
              <span>わけにもいかず･･･</span>
              <span>
                それで、とりあえず！ということで、大抵のものは実家に置かせてもらっていました。
              </span>
              <span>
                ただ、両親宅もリフォームが決まり、我が家の荷物も引き上げなくてはいけなくなってしまい･･･。
              </span>
              <span>
                引越しも当分しないので物置代わりにトランクルームを借りることにしました。
              </span>
            </div>
          </div>
          <div className="interview">
            <img src="resource/img/static/voice2/voice_case2/img_2.jpg" />
            <div className="title">2世帯での利用もお得！</div>
            <div className="question">
              Ｑ:借りてからの生活に変化はありましたか？
            </div>
            <div className="answer">
              <span>
                トランクがあると思うと、何かと無駄な買い物も増えてきた気がしますが。。。
              </span>
              <span>
                でも、生活スペースに余裕が出てきたように思えます。私の場合、衣替え時期の前後に衣装ケースごと荷物を入れ替えることにしているのですが、自宅の収納スペースにその分の荷物がなくなる訳ですので、かなりすっきり使ってますよ。
              </span>
              <span>
                あまり広くないクローゼットですが、ウォークインクローゼット状態です。
              </span>
              <span>
                去年、広いタイプの部屋に移動して、今はわたしの実家と共同で使ってます。
              </span>
              <span>
                2世帯で使っているから、使用料は割安ですよ。こんな使い方もお勧めです！
              </span>
            </div>
          </div>
          <div className="interview_footer">
            <div className="message">
              <span>まかろん様、</span>
              <span>ご協力ありがとうございました。</span>
              <span>※本文章は弊社社員のお客様インタビューを</span>
              <span>再構成し、掲載しております。</span>
            </div>
          </div>
          <Link to="/voice2/voice_case3/" className="btn black">
            その他の活用事例を見る
          </Link>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/new/voice_case2.jsx